import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { AdvisersClient } from "../../../../../Wrap/Api/Network/Advisers";
import { NotificationsClient } from "../../../../../Wrap/Api/Notifications/Notifications";
import { NotificationFilterClient } from "../../../../../Wrap/Api/User/NotificationFilter";
import { NotificationFilterReorderClient } from "../../../../../Wrap/Api/User/NotificationFilterReorder";
import { ThreadQuery } from "../../../../../Wrap/Models/Domains/Threads/ThreadQuery";
import { ThreadResponse } from "../../../../../Wrap/Models/Domains/Threads/ThreadResponse";
import { ClientNotificationFiltersModel } from "../../../../../Wrap/Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel";
import { NotificationFilterDispatcher, NotificationFilterStore } from "../Store/Variable";
import { NotificationAlertEmaiAddressesClient } from "../../../../../Wrap/Api/Notifications/NotificationAlertEmaiAddresses";
import { NotificationsDefinitionsClient } from "../../../../../Wrap/Api/Notifications/NotificationsDefinitions";
import { NotificationDefinitionCategoryClient } from "../../../../../Wrap/Api/Notifications/NotificationDefinitionCategory";
import { NotificationConfigurationClient } from "../../../../../Wrap/Api/Notifications/NotificationConfiguration";
import { NotificationConfiguration } from "../../../../../Wrap/Models/Domains/Threads/NotificationConfiguration";
import { NotificationEmailConfiguration } from "../../../../../Wrap/Models/Domains/Threads/NotificationEmailConfiguration";
import { AlertTriggerInfoClient } from "../../../../../Wrap/Api/Notifications/AlertTriggerInfo";

export class NotificationAction {
    public static getFilterList() {
        const client = new NotificationFilterClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            NotificationFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });
        promise.onError((data) => {});
    }

    public static getAdviserIds() {
        const client = new AdvisersClient();
        const promise = client.get("", "", 1, 9999999, false);
        promise.onSuccess((data) => {
            NotificationFilterDispatcher.dispatch({ actionType: ActionType.Loading, payload: data });
        });
        promise.onError((data) => {});
    }

    public static setPressedId(id: number, save?: boolean) {
        const currentId = NotificationFilterStore.getPressedId();
        let pressedId = null;
        if (save && currentId == id) {
            return NotificationFilterDispatcher.dispatch({ actionType: ActionType.Update, payload: id });
        }
        if (save != true) {
            if (id !== currentId) {
                pressedId = id;
            }
            NotificationFilterDispatcher.dispatch({ actionType: ActionType.Update, payload: pressedId });
        }
    }

    public static postNotificationFilter(data: ClientNotificationFiltersModel) {
        const client = new NotificationFilterClient();
        const promise = client.post(data);

        promise.onSuccess((data) => {
            NotificationFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
            NotificationAction.setPressedId(data?.[data?.length - 1]?.FilterId, true);
        });
        promise.onError((data) => {});
    }

    public static putNotificationFilter(data: ClientNotificationFiltersModel) {
        const client = new NotificationFilterClient();
        const promise = client.put(data);

        promise.onSuccess((d) => {
            NotificationFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: d });
            NotificationAction.setPressedId(data.FilterId, true);
        });
        promise.onError((data) => {});
    }

    public static orderNotificationFilter(data: ClientNotificationFiltersModel[]) {
        const client = new NotificationFilterReorderClient();
        const promise = client.put(data);

        promise.onSuccess((data) => {
            NotificationFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });
        promise.onError((data) => {});
    }

    public static deleteNotificationFilter(data: ClientNotificationFiltersModel) {
        const client = new NotificationFilterClient();
        const promise = client.delete(data);
        promise.onSuccess((d) => {
            NotificationFilterDispatcher.dispatch({ actionType: ActionType.Success, payload: d });
            if (data?.FilterId == NotificationFilterStore.getPressedId()) {
                NotificationFilterDispatcher.dispatch({ actionType: ActionType.Update, payload: null });
            }
        });
        promise.onError((data) => {});
    }

    public static getNotificationTable(query: ThreadQuery, callback) {
        const client = new NotificationsClient();
        const promise = client.post(query);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static getNotificationDefinitionCategories(callback) {
        const client = new NotificationDefinitionCategoryClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static getNotificationDefinitions(callback) {
        const client = new NotificationsDefinitionsClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static getNotificationConfiguration(callback) {
        const client = new NotificationConfigurationClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static getNotificationEmailConfiguration(callback) {
        const client = new NotificationAlertEmaiAddressesClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static updateNotificationEmailConfiguration(emailConfig: NotificationEmailConfiguration, callback) {
        const client = new NotificationAlertEmaiAddressesClient();
        const promise = client.put(emailConfig);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static updateNotificationConfiguration(configurations: Array<NotificationConfiguration>, callback) {
        const client = new NotificationConfigurationClient();
        const promise = client.put(configurations);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static updateThread(query: ThreadResponse, callback) {
        const client = new NotificationsClient();
        const promise = client.put(query);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }

    public static getTriggerInformation(callback) {
        const client = new AlertTriggerInfoClient();
        const promise = client.get();
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((data) => {});
    }
}
